/** Isotipo + nombre de Alpaca POS (mismo que la PWA). */
export function Brand({ caption }: { caption?: string }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <div
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-600 text-lg font-extrabold text-white"
        aria-hidden="true"
      >
        A
      </div>
      <div className="min-w-0">
        <p className="truncate text-base leading-tight font-extrabold text-slate-900">
          Alpaca <span className="text-brand-600">POS</span>
        </p>
        {caption && <p className="truncate text-xs font-medium text-slate-500">{caption}</p>}
      </div>
    </div>
  );
}
